import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getDashboard() {
    const res = await axios.get('api/dashboard/');
    return res.data;
  },
};

export const dashboard = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
